import { render, staticRenderFns } from "./TicketVue.vue?vue&type=template&id=c0f30578&"
import script from "./TicketVue.vue?vue&type=script&lang=js&"
export * from "./TicketVue.vue?vue&type=script&lang=js&"
import style0 from "./TicketVue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports